<div class="container">
    @switch (status) {
        @case (SparePartStatus.NONE) {
            <div class="indicator"></div>
            <div class="indicator"></div>
            <div class="indicator"></div>
        }
        @case (SparePartStatus.LOW) {
            <div class="indicator low"></div>
            <div class="indicator low"></div>
            <div class="indicator"></div>
        }
        @case (SparePartStatus.HIGH) {
            <div class="indicator high"></div>
            <div class="indicator high"></div>
            <div class="indicator high"></div>
        }
    }
</div>
